import React from "react";
import Accordion from "../../UI/Accordion";
import Button from "~/shared/ui/Fields/Button";
import s from "../Address.less";
import IconAutoFill from "~/components/Icons/autoFill";
import DynamicFormField from "../../UI/DynamicFormField";
import GeoField from "../GeoField";
import { addressFields } from "../helper";
import { useTranslation } from "react-i18next";
import clsx from "clsx";
import { usePermissions } from "~/shared/context/PermissionContext";

const NetxAddress = ({
  isRu,
  autoFillAddress,
  dealerInfoNameXweb,
  dealerCoordinatsXwebSto,
  dealerInfoXwebSto,
  dealerCoordinatsXwebSale,
  dealerInfoXwebSale,
  allDisabled,
}) => {
  const { hasPermission, loading: loadingPermissions } = usePermissions();
  const { t } = useTranslation();

  return (
    <>
      <div className={s.border}>
        <Accordion title="Сеть X">
          <div className={s.infoWrapper}>
            <div className={s.infoWrap}>
              {dealerInfoNameXweb.map((field) => (
                <DynamicFormField
                  key={field.name}
                  className={s.xWrapper}
                  customClassName={s.inputs}
                  disabled={
                    !(allDisabled || hasPermission("dealer.updateAddress.xweb"))
                  }
                  {...field}
                />
              ))}
            </div>
            <div className={s.infoLeft}>
              <div className={s.title}>СТО</div>
              <div className={s.fullAddress}>
                <div className={s.blockTitle}>
                  <div className={s.title}>Полный адрес:</div>
                  {hasPermission("dealer.updateAddress.xweb.sto") && (
                    <Button
                      txtBtn={t("dealers.autoFill")}
                      onClick={() => autoFillAddress("xwebStoAddress")}
                      customClassName={s.autoFillButton}
                    >
                      <IconAutoFill />
                    </Button>
                  )}
                </div>
                <DynamicFormField
                  name="xwebStoAddressfullAddress"
                  label={t("dealers.fullAddress")}
                  type="textarea"
                  customClassName={s.noneLabel}
                  className={s.bigInput}
                  disabled={true || allDisabled}
                />
              </div>
              <DynamicFormField
                name="xwebStoAddressindex"
                label={t("dealers.index")}
                type="text"
                className={clsx(s.itemIndex)}
                disabled={true || allDisabled}
              />
              {Object.entries(addressFields).map(
                ([field, settings]) => (
                  <GeoField
                    key={`xwebStoAddress${field}`}
                    prefix="xwebStoAddress"
                    field={field}
                    isRu={isRu}
                    allDisabled={
                      !(
                        allDisabled ||
                        hasPermission("dealer.updateAddress.xweb.sto")
                      )
                    }
                    {...settings}
                  />
                )
              )}
              <DynamicFormField
                name="xwebStoAddressoffice"
                label={t("dealers.office")}
                type="text"
                disabled={
                  !(
                      allDisabled ||
                      hasPermission("dealer.updateAddress.xweb.sto")
                  )
                }
                className={clsx(s.itemIndex)}
              />
              <div className={s.borderSolo} />
              {dealerCoordinatsXwebSto.map((field) => (
                <DynamicFormField
                  key={field.name}
                  {...field}
                  disabled={
                    !(
                      allDisabled ||
                      hasPermission("dealer.updateAddress.xweb.sto")
                    )
                  }
                />
              ))}
              <div className={s.borderSolo} />
              {dealerInfoXwebSto.map((field) => (
                <DynamicFormField
                  key={field.name}
                  {...field}
                  disabled={
                    true
                    // !(
                    //   allDisabled ||
                    //   hasPermission("dealer.updateAddress.xweb.sto")
                    // )
                  }
                />
              ))}
            </div>
            <div className={s.infoRight}>
              <div className={s.title}>Торговая точка</div>
              <div className={s.fullAddress}>
                <div className={s.blockTitle}>
                  <div className={s.title}>Полный адрес:</div>
                  {hasPermission("dealer.updateAddress.xweb.sale") && (
                    <Button
                      txtBtn={t("dealers.autoFill")}
                      onClick={() => autoFillAddress("xwebSaleAddress")}
                      customClassName={s.autoFillButton}
                    >
                      <IconAutoFill />
                    </Button>
                  )}
                </div>
                <DynamicFormField
                  name="xwebSaleAddressfullAddress"
                  label={t("dealers.fullAddress")}
                  type="textarea"
                  customClassName={s.noneLabel}
                  className={s.bigInput}
                  disabled={true || allDisabled}
                />
              </div>
              <DynamicFormField
                name="xwebSaleAddressindex"
                label={t("dealers.index")}
                type="text"
                className={clsx(s.itemIndex)}
                disabled={true || allDisabled}
              />
              {Object.entries(addressFields).map(
                ([field, settings]) => (
                  <GeoField
                    key={`xwebSaleAddress${field}`}
                    prefix="xwebSaleAddress"
                    field={field}
                    isRu={isRu}
                    allDisabled={
                      !(
                        allDisabled ||
                        hasPermission("dealer.updateAddress.xweb.sale")
                      )
                    }
                    {...settings}
                  />
                )
              )}
              <DynamicFormField
                name="xwebSaleAddressoffice"
                label={t("dealers.office")}
                type="text"
                disabled={
                  !(
                      allDisabled ||
                      hasPermission("dealer.updateAddress.xweb.sale")
                  )
                }
                className={clsx(s.itemIndex)}
              />
              <div className={s.borderSolo} />
              {dealerCoordinatsXwebSale.map((field) => (
                <DynamicFormField
                  key={field.name}
                  {...field}
                  disabled={
                    !(
                      allDisabled ||
                      hasPermission("dealer.updateAddress.xweb.sale")
                    )
                  }
                />
              ))}
              <div className={s.borderSolo} />
              {dealerInfoXwebSale.map((field) => (
                <DynamicFormField
                  key={field.name}
                  {...field}
                  disabled={
                    true
                    // !(
                    //   allDisabled ||
                    //   hasPermission("dealer.updateAddress.xweb.sale")
                    // )
                  }
                />
              ))}
            </div>
          </div>
        </Accordion>
      </div>
    </>
  );
};

export default NetxAddress;
